module.exports = __webpack_public_path__ + "img/login_logo.80ff78df.png";